import type { CopyCatalog } from "./copyTypes";

export const ZH_COPY: CopyCatalog = {
  "common.loading": "加载中…",
  "common.yes": "是",
  "common.no": "否",
  "common.notProvided": "未提供",
  "common.notRequired": "不需要",
  "common.requested": "已申请",
  "nav.back": "返回",
  "nav.continue": "继续",
  "nav.sendRequest": "发送申请",
  "nav.sending": "发送中…",
  "alert.completeFields": "请先填写标出的字段，然后再继续。",
  "fill.filled": "已填写",
  "fill.notFound": "未找到",
  "fill.shipmentToo": "货物也已填写：{detail}",
  "fill.palletMany": "托盘",

  "choose.title": "您希望如何申请报价？",
  "choose.manual.title": "手动填写",
  "choose.manual.description": "通过引导式表单逐步输入您的货物信息。",
  "choose.manual.action": "手动输入信息",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description": "粘贴货物信息或上传文件，我们将为您填写表单。",
  "choose.quickfill.action": "开始快速填写",

  "steps.route": "路线与订单",
  "steps.shipment": "货物",
  "steps.services": "附加服务",
  "steps.contact": "联系人",
  "steps.review": "核对",

  "page.route": "路线与订单",
  "page.routeSection": "路线",
  "page.shipment": "货物信息",
  "page.services": "附加服务",
  "page.contact": "联系信息",
  "page.contactSection": "您的联系信息",
  "page.review": "核对",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "正在分析您的文件",

  "route.hintPostcode": "请输入装货和卸货的邮政编码或城市。",
  "route.hintFullAddress": "请输入完整的装货和卸货地址。",
  "route.unsupported": "此路线不受支持。请使用适用于{loadCountry}和{unloadCountry}的表单。",
  "route.loading": "装货",
  "route.unloading": "卸货",
  "route.origin": "起点",
  "route.destination": "终点",
  "route.country": "国家/地区",
  "route.selectCountry": "选择国家/地区",
  "route.postcode": "邮政编码",
  "route.postcodePlaceholder": "例如 200000",
  "route.city": "城市",
  "route.cityPlaceholder": "输入城市",
  "route.street": "街道名称",
  "route.streetPlaceholder": "输入街道",
  "route.house": "门牌号",
  "route.housePlaceholder": "例如 12",
  "route.pickupDate": "首选提货日期：",
  "route.unloadDate": "首选卸货日期：",
  "route.datePlaceholder": "日/月/年",
  "date.clear": "清除日期",
  "date.closeCalendar": "关闭日历",
  "date.openCalendar": "打开日历",
  "route.specificDateHint": "适用于需在特定日期备妥的货物。否则我们将尽量选择最快方案。",
  "route.orderDetails": "订单信息",

  "shipment.goods": "货物描述",
  "shipment.goodsPlaceholder": "您想运输什么？",
  "shipment.weight": "总重量",
  "shipment.qty": "数量",
  "shipment.type": "类型",
  "shipment.dims": "尺寸 / LDM",
  "shipment.stackable": "可堆叠",
  "shipment.addRow": "添加货物行",
  "shipment.totalLines": "货物行总数：{count}",
  "shipment.selectDims": "选择尺寸",
  "shipment.dimsNa": "尺寸不适用",
  "shipment.sizeModeDims": "长 × 宽 × 高",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "删除货物行 {n}",
  "shipment.lineLabel": "{text}，第 {n} 行",
  "shipment.quantity": "数量",
  "qty.decrease": "减少数量",
  "qty.increase": "增加数量",
  "shipment.lengthCm": "长度（厘米）",
  "shipment.widthCm": "宽度（厘米）",
  "shipment.heightCm": "高度（厘米）",
  "shipment.dimensions": "尺寸",
  "shipment.size": "规格",
  "shipment.ldm": "LDM",

  "pallet.euro": "欧标托盘",
  "pallet.block": "块状托盘",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "半托盘",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "定制",
  "pallet.unspecified": "LDM",

  "services.aria": "附加服务",
  "services.pill.adr": "ADR",
  "services.pill.temp": "温度",
  "services.pill.tail": "尾板",
  "services.pill.ftl": "FTL",
  "services.pill.time": "时间窗口",
  "services.pill.ref": "参考号 / 备注",
  "services.pill.references": "参考号",
  "services.pill.attachments": "其他附件",
  "services.adrClass": "ADR 类别",
  "services.selectClass": "选择类别",
  "services.unNumber": "联合国编号",
  "services.unPlaceholder": "例如 1203",
  "services.min": "最低",
  "services.max": "最高",
  "services.tailLoad": "装货时使用尾板",
  "services.tailUnload": "卸货时使用尾板",
  "services.ftlCopy": "已申请整车运输。",
  "services.invoiceRef": "发票参考号",
  "services.reference": "参考号",
  "services.loadingRef": "装货参考号",
  "services.unloadingRef": "卸货参考号",
  "services.notes": "备注",
  "services.notesPlaceholder": "例如特殊说明",
  "services.deadline": "首选交货截止日期：",
  "services.deliveryHint": "适用于需在特定日期交付的货物。否则我们将尽量选择最快方案。",
  "services.loadingTime": "装货时间",
  "services.unloadingTime": "卸货时间",
  "services.window": "时间段",
  "services.fixed": "固定",
  "services.at": "于",
  "services.from": "从",
  "services.to": "至",
  "services.timeTypeAria": "{title}类型",
  "services.addFiles": "添加文件",
  "services.attachHint":
    "JPEG、PNG、GIF、WebP 或 PDF。最多 {maxFiles} 个文件，每个 {maxFileMb} MB，合计 {maxTotalMb} MB。",
  "services.adrClass1": "1 爆炸品",
  "services.adrClass2": "2 气体",
  "services.adrClass3": "3 易燃液体",
  "services.adrClass4": "4 易燃固体",
  "services.adrClass5": "5 氧化性物质",
  "services.adrClass6": "6 毒性 / 感染性物质",
  "services.adrClass7": "7 放射性物质",
  "services.adrClass8": "8 腐蚀性物质",
  "services.adrClass9": "9 杂项危险物质",
  "services.summary.adr": "危险货物（ADR）",
  "services.summary.temp": "温控",
  "services.summary.time": "时间窗口",
  "services.summary.refNotes": "参考号与备注",
  "services.summary.tail": "尾板",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "其他附件",
  "services.tail.loadUnload": "装货和卸货",
  "services.tail.loadOnly": "仅装货",
  "services.tail.unloadOnly": "仅卸货",
  "services.time.load": "装货：{value}",
  "services.time.unload": "卸货：{value}",
  "services.time.deadline": "截止日期：{value}",
  "services.time.fixedSuffix": "{time}（固定）",
  "services.time.windowRange": "{from} 至 {until}",
  "services.adr.yes": "是",
  "services.adr.classUn": "类别 {class}，联合国编号 {un}",
  "services.adr.classOnly": "类别 {class}",
  "services.adr.unOnly": "联合国编号 {un}",
  "services.temp.range": "{min}°C 至 {max}°C",
  "services.ref.invoice": "发票：{value}",
  "services.ref.loading": "装货：{value}",
  "services.ref.unloading": "卸货：{value}",

  "contact.name": "姓名",
  "contact.company": "公司",
  "contact.email": "电子邮箱",
  "contact.phone": "电话",
  "contact.comment": "补充说明",
  "contact.privacyBefore": "我同意按照 Neele-Vat 的",
  "contact.privacyLink": "隐私政策",
  "contact.privacyAfter": "处理我的个人数据。",

  "result.thankYou": "谢谢！我们已收到您的申请。",
  "result.teamWillContact": "我们的团队将在办公时间内 60 分钟内与您联系。",
  "result.teamWillContactEmail": "我们的团队将在办公时间内 60 分钟内通过 {email} 与您联系。",
  "result.previewMode": "预览模式 — 此申请并未真正发送。",
  "result.previewFiles": " 注意：预览模式下无法发送文件。",
  "result.yourReference": "您的参考号",
  "result.copy": "复制",
  "result.copied": "已复制",
  "result.nextTitle": "接下来会发生什么",
  "result.next1": "已收到申请。",
  "result.next2": "正在审核申请。",
  "result.next3": "将在 60 分钟内通过电子邮件回复。",
  "result.logged": "我们已记录您的申请。如未收到回复，请使用下方信息与我们联系。",
  "result.newQuote": "开始新的报价",
  "result.sendFailed": "我们无法发送您的申请",
  "result.preferDirect": "希望直接联系我们？",
  "result.backToEdit": "返回编辑",
  "result.tryAgain": "重试",
  "result.hideDetails": "隐藏详情",
  "result.viewSent": "查看我们发送的内容",
  "result.error.rateLimited": "您在短时间内提交了过多申请。请稍候再试。",
  "result.error.forbidden": "此申请已被拦截。请重试，或直接与我们联系。",
  "result.error.network": "目前无法发送您的申请。请检查网络连接后重试。",
  "result.error.tooLarge": "此申请过大，无法发送。请使用更小的附件或更短的说明。",
  "result.error.unsupportedType": "仅可使用 JPEG、PNG、GIF、WebP 或 PDF 文件。",
  "result.error.emailUnavailable": "无法通过电子邮件发送带附件的申请。请重试或直接与我们联系。",

  "qf.hint": "粘贴电子邮件或货物信息，或附加图片或 PDF。这将替换已输入的信息。",
  "qf.placeholder": "例如：24 个欧标托盘，从 3011 鹿特丹到 20095 汉堡，12.000 公斤，明天提货…",
  "qf.ariaPaste": "待分析的货物信息",
  "qf.attach": "附加图片或 PDF",
  "qf.disclaimer":
    "您粘贴或附加的内容仅用于填写此申请。由我们的文件分析服务处理，表单填写完成后不会保存。",
  "qf.fillForm": "填写表单",
  "qf.working": "处理中…",
  "qf.analyzing": "正在分析您的信息…",
  "qf.noFields": "未能识别任何字段。请补充更多详细信息。",
  "qf.rateLimited": "您的申请次数过多。请稍候再试。",
  "qf.blocked": "此申请已被拦截。如属意外，请与我们联系。",
  "qf.extractUnavailable": "文件分析目前不可用。请改为粘贴货物信息。",
  "qf.genericError": "出现问题。请检查网络或重试。",
  "qf.analyzeTitle": "正在分析您的文件...",
  "qf.analyzeSub": "通常只需几秒钟",
  "qf.analyzeStep1": "读取文件结构",
  "qf.analyzeStep2": "提取基本信息",
  "qf.analyzeStep3": "识别货物行",
  "qf.removeFile": "移除 {name}",

  "error.loadCountry": "请选择装货国家/地区。",
  "error.loadPostal": "请输入装货邮政编码。",
  "error.loadCity": "请输入装货城市。",
  "error.loadStreet": "请输入装货街道名称。",
  "error.loadHouseNumber": "请输入装货门牌号。",
  "error.unloadCountry": "请选择卸货国家/地区。",
  "error.unloadPostal": "请输入卸货邮政编码。",
  "error.unloadCity": "请输入卸货城市。",
  "error.unloadStreet": "请输入卸货街道名称。",
  "error.unloadHouseNumber": "请输入卸货门牌号。",
  "error.pickupDate": "请选择提货日期。",
  "error.unloadDate": "请选择卸货日期。",
  "error.invalidDate": "请输入有效日期。",
  "error.totalWeight": "请输入总重量。",
  "error.goods": "请描述货物。",
  "error.loadCityOrPostal": "请输入装货邮政编码或城市。",
  "error.unloadCityOrPostal": "请输入卸货邮政编码或城市。",
  "error.loadPostalInvalid": "请输入有效的装货邮政编码。",
  "error.loadCityInvalid": "请输入有效的装货城市。",
  "error.unloadPostalInvalid": "请输入有效的卸货邮政编码。",
  "error.unloadCityInvalid": "请输入有效的卸货城市。",
  "error.pickupPast": "提货日期不能早于今天。",
  "error.unloadPast": "卸货日期不能早于今天。",
  "error.unloadBeforePickup": "卸货日期不能早于提货日期。",
  "error.weightRange": "请输入 1 至 {max} 公斤之间的重量。",
  "error.rangePlain": "{min}–{max}。",
  "error.rangeLdm": "{min}–{max} LDM。",
  "error.rangeCm": "{min}–{max} 厘米。",
  "error.adrUn": "请输入 4 位联合国编号。",
  "error.invoiceRef": "请输入发票参考号。",
  "error.loadingRef": "请输入装货参考号。",
  "error.unloadingRef": "请输入卸货参考号。",
  "error.tempMin": "请输入最低温度。",
  "error.tempMax": "请输入最高温度。",
  "error.tempOrder": "最高温度必须至少等于最低温度。",
  "error.enterNumber": "请输入数字。",
  "error.deliveryPast": "交货截止日期不能早于今天。",
  "error.deliveryBeforePickup": "交货截止日期不能早于提货日期。",
  "error.tailSides": "请选择装货、卸货或两者。",
  "error.attachOne": "请至少附加一个文件。",
  "error.enterTime": "请输入时间。",
  "error.enterStartTime": "请输入开始时间。",
  "error.enterEndTime": "请输入结束时间。",
  "error.enterMinutes": "请输入分钟。",
  "error.completeTime": "请输入完整时间。",
  "error.enterEmail": "请输入您的电子邮箱。",
  "error.validEmail": "请输入有效的电子邮箱。",
  "error.validPhone": "请输入有效的电话号码。",
  "error.personalEmail": "不接受个人电子邮箱。",
  "error.enterName": "请输入您的姓名。",
  "error.enterCompany": "请输入您的公司。",
  "error.privacy": "请同意后继续。",
  "error.quickFillEmpty": "请粘贴货物信息或附加图片或 PDF 以填写表单。",
  "error.maxFiles": "最多可附加 {max} 个文件。",
  "error.maxFileMb": "每个文件不得超过 {max} MB。",
  "error.maxTotalMb": "附件合计不得超过 {max} MB。",
  "error.filesSkippedType": "部分文件已跳过。请使用 JPEG、PNG、GIF、WebP 或 PDF。",
  "error.emptySkipped": "已跳过空文件。",
  "error.fileEmpty": "所选文件为空。",
  "error.filesEmptyOrType": "部分文件为空，或不是 JPEG、PNG、GIF、WebP 或 PDF。",
  "error.attachType": "请附加 JPEG、PNG、GIF、WebP 或 PDF。",
  "error.subjectLong": "主题过长。",
  "error.emailTextLong": "申请内容过长。",
  "error.shortenSubject": "请缩短此值，使邮件主题不超过 {max} 个字符。",
  "error.shortenBody": "请缩短货物信息或说明，使邮件不超过 {max} 个字符。",

  "announce.choose": "请选择您希望如何申请报价",
  "announce.quickfill": "快速填写：粘贴信息或上传文件",
  "announce.route": "第 1 步，共 5 步：路线与订单",
  "announce.shipment": "第 2 步，共 5 步：货物信息",
  "announce.services": "第 3 步，共 5 步：附加服务",
  "announce.contact": "第 4 步，共 5 步：联系信息",
  "announce.review": "第 5 步，共 5 步：核对您的申请",
  "announce.received": "已收到申请",
  "announce.sendFailed": "我们无法发送您的申请",
  "announce.sendFailedAttempt": "我们无法发送您的申请（第 {n} 次尝试）",
  "announce.completeFields": "请先填写标出的字段，然后再继续。",
  "announce.sending": "正在发送您的申请…",
};
